<template>
  <div class="bitts-simple-radio-filter">
    <BittsRadioGroupCards
      :options
      :initial-value="selected"
      @change="onSelectionChanged"
    >
      <template #tooltip="{ option }">
        {{ (option as Option)?.tooltipItems?.text }}
        <BittsButton
          v-if="(option as Option)?.tooltipItems?.buttonText"
          class="my-8 w-full"
          :text="(option as Option)?.tooltipItems?.buttonText"
          size="x-small"
          type="white"
          @click="onTooltipClicked"
        />
      </template>
    </BittsRadioGroupCards>
  </div>
</template>
<script setup lang="ts">
import { computed, ref, watch } from 'vue';

import BittsButton from '../../BittsButton/BittsButton.vue';
import BittsRadioGroupCards from '../../BittsRadioGroupCards/BittsRadioGroupCards.vue';

type Option = {
  label: string;
  value: string | number;
  disabled?: boolean;
  tooltip?: boolean;
  tooltipItems?: { text?: string; buttonText?: string };
};

const { value = [], options = [] } = defineProps<{
  value?: string[];
  options?: Option[];
}>();

const emit = defineEmits<{
  (e: 'filter-changed', value: string[] | undefined): void;
  (e: 'tooltip-clicked'): void;
}>();

const firstOptionValue = computed<string | undefined>(() => {
  if (!options?.length) return undefined;
  return String(options[0]?.value);
});

const selected = ref<string | undefined>(firstOptionValue.value);

function onSelectionChanged(newVal: string) {
  const defaultVal = firstOptionValue.value;
  if (newVal === defaultVal) {
    selected.value = defaultVal;
    emit('filter-changed', undefined);
  } else {
    selected.value = newVal;
    emit('filter-changed', [newVal]);
  }
}

function onTooltipClicked() {
  emit('tooltip-clicked');
}

watch(
  () => value,
  (newVal) => {
    const defaultVal = firstOptionValue.value;
    if (!newVal.length || newVal[0] === defaultVal) {
      selected.value = defaultVal;
    } else {
      selected.value = newVal[0];
    }
  },
  { immediate: true },
);
</script>
<style scoped lang="pcss">
.bitts-simple-radio-filter {
  @apply p-8;
}

:deep(.bitts-radio-group-cards .ant-radio-wrapper) {
  @apply border-0 border-b-0 px-8 py-4 rounded-8;
}
</style>
<style lang="pcss">
.bitts-tooltip.bitts-radio-group-tooltip .ant-tooltip-inner {
  @apply ml-8;
}
</style>
